export default class MovementDefinition {
    constructor(startRow = 'A', startCol = '1', axis = 'by-row', horzDirection = 'ltr', vertDirection = 'ttb') {
        this.startRow = startRow;
        this.startCol = startCol;
        this.axis = axis;
        this.horzDirection = horzDirection;
        this.vertDirection = vertDirection;
    }
  }